import { makeStyles } from '@material-ui/core';
import ButtonRoot, { ButtonProps } from '@material-ui/core/Button';
import clsx from 'clsx';
import React from 'react';
import Loading from 'components/Loading';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface ButtonBaseProps extends ButtonProps {
  isLoading?: boolean;
  submitButton?: boolean;
  deleteButton?: boolean;
  buttonSize?: number;
  keepButton?: boolean;
  pressed?: boolean;
  outlineBlue?: boolean;
}

const Button = ({
  isLoading,
  children,
  disabled,
  submitButton,
  deleteButton,
  buttonSize,
  keepButton,
  pressed,
  outlineBlue,
  ...props
}: ButtonBaseProps) => {
  const classes = useStyles();

  return (
    <ButtonRoot
      className={clsx(classes.root, {
        [classes.green]: submitButton,
        [classes.red]: deleteButton,
        [classes.blue]: keepButton,
        [classes.pressed]: pressed,
        [classes.outlineBlue]: outlineBlue,
      })}
      disabled={disabled || isLoading}
      style={{
        height: buttonSize,
      }}
      {...props}
      data-testid="auto-sky-button"
    >
      {isLoading ? <Loading size={15} /> : children}
    </ButtonRoot>
  );
};

export default Button;
